import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { Dashboard, GetDashboardParams } from '@/features/dashboard/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/dashboard',
  }),
  tagTypes: ['Dashboard'],
  endpoints: builder => ({
    getDashboard: builder.query<Dashboard, GetDashboardParams>({
      query: params => ({
        url: '',
        params,
      }),
      providesTags: ['Dashboard'],
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardApi;
